export const BULK_UPDATE_DRAWER_BULK_UPDATE_JOB_ID = 'drawer-bulk-update';
